/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExcisetaxChargeRec.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-charge-rec";

export class AutogenModelExcisetaxChargeRec<RowType extends ModelRow> extends Endpoint<RowType, RowExcisetaxChargeRecFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExcisetaxChargeRec extends ModelRow<RowExcisetaxChargeRecFields> {
	constructor(values?: Partial<RowExcisetaxChargeRecFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExcisetaxChargeRecFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	company_id: string;
	customer_id: string;
	descr: string;
	excisetax_id: string;
	id: string;
	is_estimated: string;
	method: string;
	order_id: string;
	rate: number;
	state_id: string;
	tax_date: Date;
	units: number;
}

